export const LOAD_DB_BILLING_ADDRESS_REQUEST = 'LOAD_DB_BILLING_ADDRESS_REQUEST';
export const LOAD_DB_BILLING_ADDRESS_SUCCESS = 'LOAD_DB_BILLING_ADDRESS_SUCCESS';
export const EDIT_LOCAL_BILLING_ADDRESS = 'EDIT_LOCAL_BILLING_ADDRESS';
export const SAVE_LOCAL_BILLING_ADDRESS = 'SAVE_LOCAL_BILLING_ADDRESS';
